/*
  Product-card interactions: swatch image-swap, swatch overflow arrow, and
  hover-segment image cycling (hover-capable devices only; touch = static first image). Extracted from snippets/card-product.liquid
  (audit f37, 2026-06-10): the snippet rendered this whole script once PER
  card, so a 48-product collection page shipped ~313 KB of duplicated inline
  script. It is now a single deferred asset loaded once per page.

  Every listener is delegated on `document`, so a single global load handles
  every card on the page (and no-ops on pages with no cards). The
  __goesslCardSwatchesInit guard is retained as belt-and-suspenders in case
  the file is ever included twice.
*/
(function() {
  if (window.__goesslCardSwatchesInit) return;
  window.__goesslCardSwatchesInit = true;

  // Swatch click: swap image, update link, set active
  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('.goessl-product-card__swatch');
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation();

    var card = swatch.closest('.goessl-product-card');
    if (!card) return;
    var img = card.querySelector('.goessl-product-card__img');

    // Swap main image
    if (img && swatch.dataset.imageSrc) {
      img.src = swatch.dataset.imageSrc;
      img.srcset = swatch.dataset.imageSrcset || '';
      img.dataset.baseSrc = swatch.dataset.imageSrc;
      img.dataset.cardIndex = '0';
    }

    // 22.10.2026 (SJ: "a blue shirt is clicked, it might go to a yellow shirt"): BOTH card links - the picture and the
    // title - open the colour now shown. Only the picture link followed before, so the title still opened the old
    // colour. variant and size come from the swatch's own link (snippets/product-colour-url.liquid); every other
    // parameter of the card link stays (search tracking that assets/search-precision.js wrote after the render).
    if (swatch.dataset.href) {
      var to = new URL(swatch.dataset.href, window.location.origin);
      card.querySelectorAll('.goessl-product-card__link').forEach(function(link) {
        var url = new URL(link.getAttribute('href'), window.location.origin);
        ['variant', 'size'].forEach(function(k) {
          if (to.searchParams.has(k)) url.searchParams.set(k, to.searchParams.get(k));
          else url.searchParams.delete(k);
        });
        link.setAttribute('href', url.pathname + url.search);
      });
    }
    // ... and the quick view opens on it too
    var qv = card.querySelector('[data-quick-view-trigger]');
    if (qv && swatch.dataset.colourCode) qv.setAttribute('data-colour-code', swatch.dataset.colourCode);

    // Update active state
    card.querySelectorAll('.goessl-product-card__swatch').forEach(function(s) {
      s.classList.remove('active');
    });
    swatch.classList.add('active');

    // Clear swipe images for new color (no client-side image list available)
    card.removeAttribute('data-card-images');
    var dotsWrap = card.querySelector('[data-card-dots]');
    if (dotsWrap) dotsWrap.style.display = 'none';
  });

  // Overflow detection: show arrow when swatches overflow
  function checkOverflow() {
    // phase-separated: batch all reads, then all writes (avoids forced reflow per card)
    var wraps = Array.prototype.slice.call(document.querySelectorAll('.goessl-product-card__swatches-wrap'));
    var results = wraps.map(function(wrap) {
      var el = wrap.querySelector('.goessl-product-card__swatches');
      return el ? el.scrollWidth > el.clientWidth : null;
    });
    wraps.forEach(function(wrap, i) {
      if (results[i] === null) return;
      wrap.classList.toggle('has-overflow', results[i]);
    });
  }

  // Arrow click: scroll swatches right, or wrap to start
  document.addEventListener('click', function(e) {
    var arrow = e.target.closest('.goessl-product-card__swatches-arrow');
    if (!arrow) return;
    e.preventDefault();
    e.stopPropagation();
    var wrap = arrow.closest('.goessl-product-card__swatches-wrap');
    var container = wrap && wrap.querySelector('.goessl-product-card__swatches');
    if (!container) return;
    var scrollAmount = container.clientWidth * 0.6;
    if (container.scrollLeft + container.clientWidth >= container.scrollWidth - 5) {
      container.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkOverflow);
  } else {
    checkOverflow();
  }
  var overflowTimer;
  window.addEventListener('resize', function() {
    clearTimeout(overflowTimer);
    overflowTimer = setTimeout(checkOverflow, 150);
  });

  // r81 (SJ 29.08): image cycling is HOVER-ONLY. Touch devices keep the static
  // first image — the old touch-swipe cycler is removed, and the mouse path below
  // is capability-gated because iOS/Android synthesize mouse events on tap (a tap
  // used to fire mousemove and swap the card image to a random segment).
  var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');

  // Desktop: hover over image segments cycles images.
  // rAF-coalesced (one evaluation per frame instead of per mousemove event) with
  // a per-card cache: image list, img/dots refs and rect are resolved once on
  // enter, images prewarmed so mid-gesture swaps hit the browser cache.
  var hoverCache = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
  var hoverFrame = null;
  var lastMove = null;
  function cardState(card, imageWrap) {
    var st = hoverCache && hoverCache.get(card);
    if (!st) {
      var images = (card.dataset.cardImages || '').split('|');
      st = {
        images: images,
        img: card.querySelector('.goessl-product-card__img'),
        dots: card.querySelectorAll('.goessl-product-card__dot'),
        rect: imageWrap.getBoundingClientRect()
      };
      images.forEach(function(u) { var pre = new Image(); pre.src = u; });
      if (hoverCache) hoverCache.set(card, st);
    }
    return st;
  }
  window.addEventListener('resize', function() { hoverCache = typeof WeakMap !== 'undefined' ? new WeakMap() : null; });
  document.addEventListener('mousemove', function(e) {
    if (!hoverCapable.matches) return;
    lastMove = e;
    if (hoverFrame) return;
    hoverFrame = requestAnimationFrame(function() {
      hoverFrame = null;
      var ev = lastMove;
      var imageWrap = ev.target.closest && ev.target.closest('.goessl-product-card__image');
      var card = imageWrap && imageWrap.closest('[data-card-images]');
      if (!card) return;
      var st = cardState(card, imageWrap);
      if (!st.img || st.images.length < 2) return;
      var relX = (ev.clientX - st.rect.left) / st.rect.width;
      var idx = Math.min(Math.max(0, Math.floor(relX * st.images.length)), st.images.length - 1);
      var current = parseInt(st.img.dataset.cardIndex || '0', 10);
      if (idx !== current) {
        st.img.src = st.images[idx];
        st.img.srcset = '';
        st.img.dataset.cardIndex = idx;
        st.dots.forEach(function(d, i) { d.classList.toggle('is-active', i === idx); });
      }
    });
  }, { passive: true });

  // Reset to base image on mouse leave (swatch-selected or first)
  document.addEventListener('mouseout', function(e) {
    if (!hoverCapable.matches) return;
    var imageWrap = e.target.closest('.goessl-product-card__image');
    if (!imageWrap || imageWrap.contains(e.relatedTarget)) return;
    var card = imageWrap.closest('.goessl-product-card');
    if (!card) return;
    var img = card.querySelector('.goessl-product-card__img');
    var dots = card.querySelectorAll('.goessl-product-card__dot');
    if (!img) return;
    var baseSrc = img.dataset.baseSrc;
    var images = (card.dataset.cardImages || '').split('|');
    if (baseSrc) {
      img.src = baseSrc;
    } else if (images.length > 1) {
      img.src = images[0];
    }
    img.srcset = '';
    img.dataset.cardIndex = '0';
    dots.forEach(function(d, i) { d.classList.toggle('is-active', i === 0); });
  });
})();
